/**
 * Base color scheme for Vuse Admin UI
 * Setting it's titled as Theme builder
 * Basically refers to color scheme of 3 based navigation of an app.
 * Ref: store/modules/swatch.js
 */
export default {
  // navDrawerAlphaImage: "/static/sidebar-imgs/sb-bg7.jpg",
  navDrawerScheme: "md-deep-purple-700",
  navToolbarScheme: "md-deep-purple-700",
  navFooterScheme: "md-grey-400",
  alpha: 1, // Transparent Background of the sidebar navigation
  variant: false
};
